module.exports = __webpack_public_path__ + "static/media/2.8f5ee3ff.svg";